import {
  ContractorPaymentTypeEnum,
  RepairPaymentTypeEnum,
  RepairTypeEnum,
} from '@vatos-pas/common';

import { CostStructurePercentageField } from './costStructurePercentage';

type DeriveRepairPaymentModeInput = {
  repairType: string | undefined;
  resourceType: string;
  contractorBumperPaymentType: string | undefined;
  formulaPaymentType: string | undefined;
};

export type RepairPaymentMode = {
  // The payment type the UI behaves as. Special Jobs bumpers override the
  // formula: Per-Board renders as Percentage, Per-Hour as PerHour.
  effectivePaymentType: string | undefined;
  isSpecialJobsPerBoardBumper: boolean;
  isSpecialJobsPerHourBumper: boolean;
  // Which Cost Structure percentage a Percentage payment reads.
  percentageField: CostStructurePercentageField;
};

// Single derivation for the special-jobs bumper overrides, so the show/hide
// memos, the percentage lookup, and the submit payload all read one concept
// instead of repeating the repairType/resourceType/paymentType conjunction.
export const deriveRepairPaymentMode = ({
  repairType,
  resourceType,
  contractorBumperPaymentType,
  formulaPaymentType,
}: DeriveRepairPaymentModeInput): RepairPaymentMode => {
  const isSpecialJobsBumper =
    repairType === RepairTypeEnum.SpecialJobs && resourceType === 'Bumper';

  const isSpecialJobsPerBoardBumper =
    isSpecialJobsBumper &&
    contractorBumperPaymentType === ContractorPaymentTypeEnum.PerBoard;

  const isSpecialJobsPerHourBumper =
    isSpecialJobsBumper &&
    contractorBumperPaymentType === ContractorPaymentTypeEnum.PerHour;

  const effectivePaymentType = isSpecialJobsPerBoardBumper
    ? RepairPaymentTypeEnum.Percentage
    : isSpecialJobsPerHourBumper
    ? RepairPaymentTypeEnum.PerHour
    : formulaPaymentType;

  return {
    effectivePaymentType,
    isSpecialJobsPerBoardBumper,
    isSpecialJobsPerHourBumper,
    percentageField: isSpecialJobsPerBoardBumper
      ? 'specialJobsPercentage'
      : 'pieceworkPercentage',
  };
};
